import { getBrowserOrigin } from '../lib/browser';
import Config from '../Config';

const config = new Config();

// allowed logoutRoute parameter:
//
// -> /intro
// -> /account-type
// -> /logout.html
// -> /logout.html?manual

 export default function signOutUrl(logoutRoute) {
  const returnTo = getBrowserOrigin() + logoutRoute;
  return `${config.auth0LogoutUrl}?client_id=${config.auth0ClientId}&returnTo=${returnTo}`;
}
